import { startOfMonth, subDays, subMonths, today } from '../../../../utils/date';

export const lastTransitionDate = startOfMonth(subMonths(subDays(today(), 4), 2));
